import type { ComponentProps } from 'react';

import Search from '@/public/assets/svg/Icon/Search.svg';

export const IconSearch = ({ ...props }: ComponentProps<'svg'>) => {
  return <Search {...props} />;
};
